import { useState, useEffect } from "react";
import "./styles/app.style.css";

import { Intro } from "./components/intro.component";
import { Nav } from "./components/nav.component";
import { Hero } from "./components/hero.component";
import { About } from "./components/about.component";
import { Philosophy } from "./components/philosophy.component";
import { Listen } from "./components/listen.component";
import { Contact } from "./components/contact.component";
import { Footer } from "./components/footer.component";
import { useActiveSection } from "./hooks/use-active-section.hook";
import { useGoogleAnalytics } from "./hooks/use-google-analytics.hook";
import { useScrollReveal } from "./hooks/use-scroll-reveal.hook";

const SECTION_IDS = ["about", "philosophy", "listen", "contact"];

export function App() {
  const skipIntro = new URLSearchParams(window.location.search).has("skip-intro");
  const [introComplete, setIntroComplete] = useState(skipIntro);
  const activeSection = useActiveSection(SECTION_IDS);
  useScrollReveal(introComplete);
  useGoogleAnalytics();

  useEffect(() => {
    if (!introComplete) return;
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, [introComplete]);

  return (
    <>
      {!introComplete && <Intro onComplete={() => setIntroComplete(true)} />}
      <div
        id="site"
        style={{
          opacity: introComplete ? 1 : 0,
          transition: "opacity 1.8s ease",
        }}
      >
        <Nav activeSection={activeSection} />
        <Hero />
        <About />
        <Philosophy />
        <Listen />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
